import { startOfDay } from "date-fns";

/** Summarize event show schedule for UI badges / helpers (Phase 23). */
export function summarizeEventShowSchedule(
  shows: Array<{ showDate: Date | string }>,
): {
  showCount: number;
  calendarDayCount: number;
  sameDayDiscountApplies: boolean;
  /** Number of show slots billed at additionalShowPercent (same-day 2+) */
  discountedShowCount: number;
} {
  const showCount = shows.length;
  if (showCount === 0) {
    return {
      showCount: 0,
      calendarDayCount: 0,
      sameDayDiscountApplies: false,
      discountedShowCount: 0,
    };
  }

  const dayCounts = new Map<number, number>();
  for (const show of shows) {
    const key = startOfDay(new Date(show.showDate)).getTime();
    dayCounts.set(key, (dayCounts.get(key) ?? 0) + 1);
  }

  let discountedShowCount = 0;
  for (const count of dayCounts.values()) {
    if (count > 1) discountedShowCount += count - 1;
  }

  return {
    showCount,
    calendarDayCount: dayCounts.size,
    sameDayDiscountApplies: discountedShowCount > 0,
    discountedShowCount,
  };
}
